import moment from "moment-timezone";

export const friendlyDateTime = (value) => moment(value).format("dddd, Do MMM YYYY h:mma");

export const formatDate = (value, withTime = false) => {
  if (value == null || value === "") return null;
  const parsed = moment(value);
  if (!parsed.isValid()) return null;
  return parsed.format(withTime ? "lll" : "ll");
};

export const calendarToday = () => moment().format("YYYY-MM-DD");
